import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MenuItemService } from '@shared/services/menu-item.service';
import { Observable, of } from 'rxjs';
import { NavMenuItem } from '@core/models/nav-menu-item.model';
import { UserModel } from '@features/user/models/user.model';
import { LogoService } from '@core/services/logo.service';
import { UserService } from '@features/user/services/user.service';
import { catchError, distinctUntilChanged, map, switchMap } from 'rxjs/operators';
import { SidebarService } from '@core/components/sidebar/services/sidebar.service';
import { UserModules } from '@core/enums/user-modules.enum';
import { FontAwesomeIcon } from '@core/enums/font-awesome-icon.enum';
import { RoleTypeKeys } from '@core/enums/role-type-keys.enum';
import { Router } from '@angular/router';

@Component({
    selector: 'app-sidebar',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['./sidebar.component.scss'],
    standalone: false
})
export class SidebarComponent implements OnInit {
  public activeMenuItem$: Observable<NavMenuItem>;
  public currentUser: UserModel;
  public showInfoBox = false;
  public logo$: Observable<string>;
  public infoBoxRoles = [RoleTypeKeys.supervisor, RoleTypeKeys.vo, RoleTypeKeys.voAdmin, RoleTypeKeys.mbo, RoleTypeKeys.mboAdmin, RoleTypeKeys.admin];
  public circleIcon: FontAwesomeIcon = FontAwesomeIcon.InfoCircle;
  constructor(
    private menuItemService: MenuItemService,
    private logoService: LogoService,
    private userService: UserService,
    private cdr: ChangeDetectorRef,
    private sidebarService: SidebarService,
    private router: Router,
  ) {
  }

  public ngOnInit(): void {
    this.activeMenuItem$ = this.menuItemService.getActiveMenuItem();
    this.currentUser = this.userService.getCurrentUser() as UserModel;

    if (this.activeMenuItem$) {
      this.activeMenuItem$.subscribe(item => {
        this.showInfoBox = item?.key === UserModules.GRIP_DOORSTROOMDOSSIER && this.infoBoxRoles.includes(this.currentUser?.currentRoleType?.key as RoleTypeKeys)
      });
    }

    this.logo$ = this.logoService.currentUserRoleChanged.pipe(
      map((user: UserModel) => user?.currentInstance?.belongs_to_region_id ?? null),
      distinctUntilChanged(),
      switchMap((regionId: string) => {
        if (!regionId) {
          return of(null);
        }

        return this.logoService.getMenuLogo(regionId).pipe(
          map((logo) => logo.url),
          catchError(() => of(null)),
        );
      }),
    );

    this.cdr.detectChanges();
  }

  public menuItemClick(event: PointerEvent, url: string): void {
      this.sidebarService.setEvent(event);

      if (this.router.url === url) {
          this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate([url]);
          });
      } else {
          this.router.navigate([url]);
      }
  }

  public redirectToDDD(): void {
    window.open('https://doorstroomdossier.nl/', '_blank');
  }
}
